// extracted by mini-css-extract-plugin
export default {"menu":"DropDownMenu_menu__7Um33","nav":"DropDownMenu_nav__o6uEC container"};